import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box component="footer">
      <Box sx={{ bgcolor: "secondary.main", py: 6 }}>
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: "column", md: "row" }}
            divider={
              <Divider
                orientation="vertical"
                flexItem
                color={theme.palette.grey[400]}
                component="hr"
              />
            }
            spacing={{ xs: 0, md: 4 }}
            sx={{ marginBottom: 4 }}
          >
            <FooterLink href="https://www.britishcouncil.org/terms">
              {t("footer.termsOfUse")}
            </FooterLink>
            <FooterLink href="https://www.britishcouncil.org/accessibility">
              {t("footer.accessibility")}
            </FooterLink>
            <FooterLink href="https://www.britishcouncil.org/privacy-cookies">
              {t("footer.privacyAndCookies")}
            </FooterLink>
            <FooterLink href="https://www.britishcouncil.org/privacy-cookies/data-protection">
              {t("footer.dataProtection")}
            </FooterLink>
          </Stack>

          <Typography sx={{ color: "common.white" }}>
            © 2025 British Council <br />
            {t("footer.copyright")}
            <br />
            {t("footer.copyright2")}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

const FooterLink = ({
  children,
  href,
}: PropsWithChildren<{ href: string }>) => (
  <Link
    key={href}
    href={href}
    underline="hover"
    sx={{
      color: "common.white",
      padding: "5px 0",
      fontWeight: "700",
      fontFamily: "Arial",
    }}
  >
    {children}
  </Link>
);
